import React from "react";
import { useState, useEffect } from "react";
// import OneYearAnniversary from "../assets/Home/Gov's1YearAnniversary.jpg";
import styles from "./style.module.css";

const NewsModal = ({ modalShowing, toggleModal }) => {
	const [modalVisible, setModalVisible] = useState(false);

	// checking if the user has visited the page and has seen the news modal //
	useEffect(() => {
		if (!localStorage.getItem("modalShown")) {
			displayModal();
		}
	}, []);

	const displayModal = () => {
		setModalVisible(true);
		localStorage.setItem("modalShown", "true");
	};

	// const downloadImage = () => {
	// 	const link = document.createElement("a");
	// 	link.href = OneYearAnniversary;
	// 	link.download = "Gov. Peter Mbah's 1 year anniversary";
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link);
	// };

	return (
		<div
			className={`${styles.modalOverlay} ${
				modalVisible ? styles.visible : " "
			}`}
			onClick={() => toggleModal(!modalShowing)}
		>
			<div className={styles.modalContent}>
				{/* <h2 className={styles.clickMe}>Click Me </h2>
				<img
					src={OneYearAnniversary}
					alt="AnualReportNotification"
					className={styles.AnualReportNotificationImage}
					onClick={downloadImage}
				/> */}
				<h2 className={styles.text__announcement_header}>
					We are Recruiting!
				</h2>
				<p className={styles.text__announcement_description}>
					Please, apply here: <br />{" "}
					<a
						href="https://bit.ly/3RSPZ8y"
						target="_blank"
						rel="noreferrer"
					>
						https://bit.ly/3RSPZ8y
					</a>
				</p>
			</div>
		</div>
	);
};

export default NewsModal;
